import dayjs from 'dayjs';
import KpiWeightType from '../enums/KpiWeightType.js';

export default class KpiWeight {
  constructor(data) {
    this.id = data?.id;
    this.jobId = data?.jobId;
    this.type = data?.type ? KpiWeightType.of(data.type) : null;
    this.value = data?.value ? Number(data.value) : null;
    this.createdAt = data?.createdAt ? dayjs(data.createdAt) : null;
    this.updatedAt = data?.updatedAt ? dayjs(data.updatedAt) : null;
  }
}
